import { useState, useRef } from 'react';
import readXlsxFile from 'read-excel-file'
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { post } from '../helpers/api_helper';
import { POST_ADD_EDIT_EMPLOYEE } from '../helpers/url_helper';
import { useTranslation } from 'react-i18next';
import $ from 'jquery';

export default function ImportEmployees(props) {
    const { t } = useTranslation();

    const [optionList, setOptionList] = useState([]);
    const [ProductList, setProductList] = useState([]);
    const [ShowTable, setShowTable] = useState(false);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [, forceUpdate] = useState();
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({
        employeeCode: 0,
        name: 1,
        gender: 2,
        mobileNumber: 3,
        email: 4,
        address: 5,
        contactPersonName: 6,
        contactPersonRelation: 7,
        contactPersonMobileNumber: 8,
        bankName: 9,
        accountNumber: 10,
        ifscCode: 11,
        salary: 12,
        salaryType: 13,
        workingHours: 14,
    });


    // input text change handler
    const handleInputChange = async (event) => {
        event.persist();
        if (event.target.name === 'file') {
            readXlsxFile(event.target.files[0]).then(function (rows) {
                // var filteredData = rows.map((row) => row.filter((cell) => cell !== null));
                var filteredData = rows.filter(a => !a.every(ax => a === undefined));

                if (filteredData.length > 0) {
                    setOptionList(filteredData[0]);
                    filteredData.splice(0, 1);
                    setProductList(filteredData);

                    setShowTable(false);
                    $('.modal-close').click();
                    const myModalEl = document.getElementById('UploadProductModal1');
                    new window.bootstrap.Modal(myModalEl).show();

                } else {
                    toast.error('no any data');
                }
            })
        } else {
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            setShowTable(true);
        }
    }

    const Import = async () => {
        SetButtonDisabled(true);
        if (ProductList.length > 0) {
            var i = 0;
            var isSuccess = true;
            for (const employee of ProductList) {

                const employeeData = {
                    employeeId : 0,
                    employeeCode: employee[form_inputs.employeeCode],
                    name: employee[form_inputs.name],
                    gender: employee[form_inputs.gender],
                    mobileNumber: employee[form_inputs.mobileNumber],
                    email: employee[form_inputs.email],
                    address: employee[form_inputs.address],
                    contactPersonName: employee[form_inputs.contactPersonName],
                    contactPersonRelation: employee[form_inputs.contactPersonRelation],
                    contactPersonMobileNumber: employee[form_inputs.contactPersonMobileNumber],
                    bankName: employee[form_inputs.bankName],
                    accountNumber: employee[form_inputs.accountNumber],
                    ifscCode: employee[form_inputs.ifscCode],
                    salary: employee[form_inputs.salary],
                    salaryType: employee[form_inputs.salaryType],
                    workingHours: employee[form_inputs.workingHours],
                }
                var res_data = await post(POST_ADD_EDIT_EMPLOYEE, employeeData);
                if (res_data.status) {
                    ProductList[i]['success'] = true;
                } else {
                    ProductList[i]['error'] = res_data.message;
                    isSuccess = false;
                }

                setProductList({ ...ProductList })
                i++;
            }
            props.call_back();
            if (isSuccess) {
                $('.modal-close').click();
            }
            SetButtonDisabled(false);
        } else {
            toast.error('No Data Found!');
            SetButtonDisabled(false);
        }
    }


    const check_row = (value) => {
        if (value['success']) {
            return 'table-success'
        }
        if (value['error']) {
            return 'table-danger'
        }
    }
    return (<>
        <div className="modal fade" id="ImportEmployees" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h6 className="modal-title mt-0"></h6>
                        <svg className='pointer modal-close' data-bs-dismiss="modal" aria-label="Close" width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.9993 2.66666C8.65268 2.66666 2.66602 8.65332 2.66602 16C2.66602 23.3467 8.65268 29.3333 15.9993 29.3333C23.346 29.3333 29.3327 23.3467 29.3327 16C29.3327 8.65332 23.346 2.66666 15.9993 2.66666ZM20.4793 19.0667C20.866 19.4533 20.866 20.0933 20.4793 20.48C20.2793 20.68 20.026 20.7733 19.7727 20.7733C19.5193 20.7733 19.266 20.68 19.066 20.48L15.9993 17.4133L12.9327 20.48C12.7327 20.68 12.4793 20.7733 12.226 20.7733C11.9727 20.7733 11.7193 20.68 11.5193 20.48C11.1327 20.0933 11.1327 19.4533 11.5193 19.0667L14.586 16L11.5193 12.9333C11.1327 12.5467 11.1327 11.9067 11.5193 11.52C11.906 11.1333 12.546 11.1333 12.9327 11.52L15.9993 14.5867L19.066 11.52C19.4527 11.1333 20.0927 11.1333 20.4793 11.52C20.866 11.9067 20.866 12.5467 20.4793 12.9333L17.4127 16L20.4793 19.0667Z" fill="black" />
                        </svg>
                    </div>
                    <div className="modal-body">
                        <div className='row mb-4'>
                            <div className='col-sm-12 '>
                                <div className='text-center border border-dashed rounded pointer'>
                                    <label for='upload_file' className='pt-5 pb-4 pointer w-100'>
                                        <span className='btn btn-md btn-secondary mb-3 pl-4 pr-4'>{t('employee.import.upload')}</span>
                                        <h6 className='mb-0'>{t('employee.import.uploadTile')}</h6>
                                        <p><small>{t('employee.import.uploadTileInfo')}</small></p>
                                    </label>
                                    <input type='file' name='file' onChange={handleInputChange} id="upload_file" className='d-none' accept='.xlsx, .xls, .csv' />
                                </div>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-sm-12 text-center '>
                                <a href='/import-employees.xlsx' className='text-primary'>{t('employee.import.download')}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="modal fade" id="UploadProductModal1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document" style={{ "maxWidth": '1100px' }}>
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h6 className="modal-title mt-0"></h6>
                        <svg className='pointer modal-close' data-bs-dismiss="modal" aria-label="Close" width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.9993 2.66666C8.65268 2.66666 2.66602 8.65332 2.66602 16C2.66602 23.3467 8.65268 29.3333 15.9993 29.3333C23.346 29.3333 29.3327 23.3467 29.3327 16C29.3327 8.65332 23.346 2.66666 15.9993 2.66666ZM20.4793 19.0667C20.866 19.4533 20.866 20.0933 20.4793 20.48C20.2793 20.68 20.026 20.7733 19.7727 20.7733C19.5193 20.7733 19.266 20.68 19.066 20.48L15.9993 17.4133L12.9327 20.48C12.7327 20.68 12.4793 20.7733 12.226 20.7733C11.9727 20.7733 11.7193 20.68 11.5193 20.48C11.1327 20.0933 11.1327 19.4533 11.5193 19.0667L14.586 16L11.5193 12.9333C11.1327 12.5467 11.1327 11.9067 11.5193 11.52C11.906 11.1333 12.546 11.1333 12.9327 11.52L15.9993 14.5867L19.066 11.52C19.4527 11.1333 20.0927 11.1333 20.4793 11.52C20.866 11.9067 20.866 12.5467 20.4793 12.9333L17.4127 16L20.4793 19.0667Z" fill="black" />
                        </svg>
                    </div>

                    {!ShowTable && <div className="modal-body">
                        <form className="av-invalid" onSubmit={handleSubmit}>
                            <div className='row mb-4'>
                                <div className='col-sm-12 text-center'>
                                    <h5>{t('employee.import.matchColumnsToYourBoard')}</h5>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-2'></div>
                                <div className='col-sm-8'>

                                    <div className='row mb-3'>
                                        <div className='col-6 d-none d-sm-block'>
                                            <h6><b>{t('employee.import.fileColumns')}</b></h6>
                                        </div>
                                        <div className='col-6 d-none d-sm-block'>
                                            <h6><b>{t('employee.import.boardColumns')}</b></h6>
                                        </div>
                                    </div>

                                    <div className='row mb-3'> 
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.employeeCode')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='employeeCode' onChange={handleInputChange} value={form_inputs.employeeCode}>
                                                <option value="">{t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'> 
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.fullName')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='name' onChange={handleInputChange} value={form_inputs.name}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.gender')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='gender' onChange={handleInputChange} value={form_inputs.gender}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                            {simpleValidator.current.message('column', form_inputs.gender, 'required')}
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.mobileNumber')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='mobileNumber' onChange={handleInputChange} value={form_inputs.mobileNumber}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                            {simpleValidator.current.message('column', form_inputs.mobileNumber, 'required')}
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.emailAddress')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='emailAddress' onChange={handleInputChange} value={form_inputs.emailAddress}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.address')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='address' onChange={handleInputChange} value={form_inputs.address}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.contactPersonName')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='contactPersonName' onChange={handleInputChange} value={form_inputs.contactPersonName}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.relationship')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='contactPersonRelation' onChange={handleInputChange} value={form_inputs.contactPersonRelation}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.contactMobile')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='contactPersonMobileNumber' onChange={handleInputChange} value={form_inputs.contactPersonMobileNumber}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.bankName')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='bankName' onChange={handleInputChange} value={form_inputs.bankName}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.accountNumber')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='accountNumber' onChange={handleInputChange} value={form_inputs.accountNumber}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.IFSCCode')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='ifscCode' onChange={handleInputChange} value={form_inputs.ifscCode}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.salaryAmount')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='salary' onChange={handleInputChange} value={form_inputs.salary}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                            {simpleValidator.current.message('column', form_inputs.salary, 'required')}
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.salaryType')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='salaryType' onChange={handleInputChange} value={form_inputs.salaryType}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                            {simpleValidator.current.message('column', form_inputs.salaryType, 'required')}
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-12 col-sm-6'>
                                            <label className='form-label mt-2 text-capitalize'>{t('employee.form.workingHours')}</label>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <select className="form-control" name='workingHours' onChange={handleInputChange} value={form_inputs.workingHours}>
                                                <option value=""> {t('employee.import.selectColumn')}</option>
                                                {optionList && Object.entries(optionList).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                            {simpleValidator.current.message('column', form_inputs.workingHours, 'required')}
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-6'>
                                    <button type="button" className="btn btn-sm btn-secondary pl-3 pr-3" onClick={() => {
                                        $('.modal-close').click();
                                    }}>{t('back')}</button>
                                </div>
                                <div className='col-6 text-right'>
                                    <button type='submit' className="btn btn-sm btn-primary c-btn-primary pl-3 pr-3">{t('next')}</button>
                                </div>
                            </div>
                        </form>
                    </div>}

                    {ShowTable && <div className="modal-body">
                        <div className='row mb-4'>
                            <div className='col-sm-12 text-center'>
                                <h5>{t('employee.import.viewTitle')}</h5>
                                <p className='mb-0'>{t('employee.import.errorTitle')}</p>
                                <p className='mb-0'>{t('employee.import.successTitle')}</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <div className='col-sm-12' >
                                    <div className='table-responsive'>
                                        <table className='table table-sm '>
                                            <thead>
                                                <tr>
                                                    <th className='text-nowrap text-capitalize'>Sr.</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.employeeCode')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.fullName')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.gender')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.mobileNumber')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.emailAddress')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.address')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.contactPersonName')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.relationship')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.contactMobile')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.bankName')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.accountNumber')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.IFSCCode')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.salaryAmount')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.salaryType')}</th>
                                                    <th className='text-nowrap text-capitalize'>{t('employee.form.workingHours')}</th>
                                                    <th className='text-nowrap text-capitalize'></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ProductList && Object.entries(ProductList).map(([key, value]) => (
                                                    <tr key={key} className={check_row(value)}>
                                                        <td>{++key} {check_row.bind(this, value)} </td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.employeeCode]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.name]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.gender]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.mobileNumber]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.email]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.address]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.contactPersonName]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.contactPersonRelation]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.contactPersonMobileNumber]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.bankName]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.accountNumber]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.ifscCode]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.salary]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.salaryType]}</td>
                                                        <td className='text-left text-nowrap'>{value[form_inputs.workingHours]}</td>
                                                        <td className='text-left text-nowrap'>{value['error']}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <button type="button" className="btn btn-sm btn-secondary pl-3 pr-3" onClick={() => {
                                    setShowTable(false);
                                }}>{t('back')}</button>
                            </div>
                            <div className='col-6 text-right'>
                                <button type='button' onClick={Import} disabled={ButtonDisabled} className="btn btn-sm btn-primary c-btn-primary pl-3 pr-3">{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('employee.import.import')}</button>
                            </div>
                        </div>
                    </div>}

                </div>
            </div>
        </div>

    </>);
}